<template>
  <div class="image-carousel overflow-hidden" style="border-top-left-radius: inherit; border-top-right-radius: inherit" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
    <div v-for="(image, i) in images" :key="'TwImageCarousel_' + i" class="relative">
      <div v-if="requestedImageSlides.includes(i)" v-show="i === imageSlide">
        <tw-image :src="image" :key="i" :width="width" :height="height" :aspect-ratio="aspectRatio" />
        <div v-if="(forceArrows || images.length > 1) && !hideArrows" class="image-carousel__control cursor-pointer absolute left-2 top-1/2 flex items-center justify-center rounded-full bg-black bg-opacity-50" @mousedown.prevent.stop="() => {}" @click.prevent.stop="decrementSlide" style="width: 2.2rem; height: 2.2rem; transform: translateY(-50%)">
          <icon-chevron-left size="24" class="text-white" />
        </div>
        <div v-if="(forceArrows || images.length > 1) && !hideArrows" class="image-carousel__control cursor-pointer absolute right-2 top-1/2 flex items-center justify-center rounded-full bg-black bg-opacity-50" @mousedown.prevent.stop="() => {}" @click.prevent.stop="incrementSlide" style="width: 2.2rem; height: 2.2rem; transform: translateY(-50%)">
          <icon-chevron-right size="24" class="text-white" />
        </div>
        <div v-if="images.length > 1 && !hideCount" class="image-carousel__control absolute right-2 bottom-2 rounded-full py-1 px-2 bg-gray-900 bg-opacity-60 text-white text-2xs">
          {{ i + 1 }} / {{ images.length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwImage from "@/components/Tailwind/TwImage";
import IconChevronRight from "@/components/Icon/IconChevronRight";
import IconChevronLeft from "@/components/Icon/IconChevronLeft";

export default {
  name: "TwImageCarousel",
  components: { IconChevronLeft, IconChevronRight, TwImage },
  props: {
    images: {
      type: Array,
      required: true
    },
    width: {
      default: "full"
    },
    height: {
      default: "auto"
    },
    aspectRatio: {
      default: "",
      required: false,
    },
    hideCount: {
      type: Boolean,
      default: false
    },
    forceArrows: {
      type: Boolean,
      default: false
    },
    hideArrows: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      imageSlide: 0,
      requestedImageSlides: [0],
      touchStartX: 0,
      touchEndX: 0
    };
  },
  watch: {
    imageSlide: function(newVal) {
      if(this.requestedImageSlides.indexOf(newVal) === -1) {
        this.requestedImageSlides.push(newVal);
      }
    }
  },
  computed: {
    imageHeight() {
      return this.height;
    }
  },
  methods: {
    decrementSlide() {
      this.$emit("decrement-slide");
      this.imageSlide = (this.imageSlide === 0) ? this.images.length - 1 : this.imageSlide - 1;
    },
    incrementSlide() {
      this.$emit("increment-slide");
      this.imageSlide = (this.imageSlide === (this.images.length - 1)) ? 0 : this.imageSlide + 1;
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      this.handleSwipe();
    },
    handleSwipe() {
      const swipeThreshold = 50; // Minimum distance for a swipe
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swiped left - go to next image
          this.incrementSlide();
        } else {
          // Swiped right - go to previous image
          this.decrementSlide();
        }
      }
    }
  }
}
</script>

<style scoped>
.image-carousel__control {
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
</style>